import {
    Component,
    Input,
    OnInit,
    OnChanges,
    inject,
    signal,
    computed,
} from '@angular/core';
import {
    Address,
    Sta,
} from '../../../projects/shared-lib/src/lib/models/address';
import {
    BreakpointsLib,
    constSystem,
} from '../../../projects/shared-lib/src/lib/utils/const-system';
import { BannersService } from '../banners.service';
import { TranslateService, TranslatePipe } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ClientService } from '../../modules/client/client.service';
import { AnalyticsService } from '../../modules/shared/services/analytics.service';
import { HelpsService } from '../../../projects/shared-lib/src/lib/utils/helps.service';
import { FilterPageService } from './filter-page.service';
import {
    RangeDates,
    DateRangeSelectAdvancedComponent,
} from '../../../projects/shared-lib/src/lib/component/date-range-select-advanced/date-range-select-advanced.component';
import {
    MatFormField,
    MatPrefix,
    MatLabel,
    MatSuffix,
    MatError,
    MatHint,
    MatFormFieldModule,
} from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput, MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { MatButton, MatButtonModule } from '@angular/material/button';
import { MatMenuTrigger, MatMenu } from '@angular/material/menu';
import { FormErrorMessageComponent } from '../../modules/shared/component/form/form-error-message/form-error-message.component';
import { JsonPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { LocationPage } from '../../../projects/shared-lib/src/lib/models/location-page';
import { MatSelect } from '@angular/material/select';
import {
    MatOption,
    provideNativeDateAdapter,
    DateAdapter,
    MAT_DATE_LOCALE,
} from '@angular/material/core';
import {
    MatDatepickerActions,
    MatDatepickerApply,
    MatDatepickerCancel,
    MatDatepickerModule,
    MatDatepickerToggle,
    MatDateRangeInput,
    MatDateRangePicker,
    MatDatepickerIntl,
} from '@angular/material/datepicker';
import { TranslateLangPipe } from '../../../projects/shared-lib/src/lib/pipe/translate-lang.pipe';
import { subBreakpointObserver } from '../../../projects/shared-lib/src/lib/utils/action';
import { CategoryFilter } from '../../../projects/shared-lib/src/lib/models/category-filter';

@Component({
    selector: 'tw-filter-pages-events',
    templateUrl: './filter-pages-events.component.html',
    styleUrls: ['./filter-pages-events.component.scss'],
    imports: [
        MatFormField,
        MatIcon,
        MatPrefix,
        MatLabel,
        MatInput,
        FormsModule,
        MatButton,
        MatMenuTrigger,
        MatMenu,
        MatSuffix,
        MatError,
        FormErrorMessageComponent,
        NgClass,
        DateRangeSelectAdvancedComponent,
        TranslatePipe,
        MatSelect,
        MatOption,
        JsonPipe,
        MatDateRangeInput,
        MatHint,
        MatDatepickerToggle,
        MatDateRangePicker,
        MatDatepickerActions,
        MatDatepickerCancel,
        MatDatepickerApply,
        MatFormFieldModule,
        MatInputModule,
        MatDatepickerModule,
        MatButtonModule,
        TranslateLangPipe,
        NgTemplateOutlet,
    ],
    providers: [provideNativeDateAdapter()],
})
export class FilterPagesEventsComponent implements OnInit, OnChanges {
    @Input() locationVenue: LocationPage[];
    @Input() category: Partial<CategoryFilter>[];
    @Input() showCategory = true;
    @Input() showLocation: boolean;
    @Input() showDate = true;
    @Input() showSearch = true;
    @Input() showProvince;
    multiple = false;
    provinces = <Sta[]>constSystem.world.provinces;
    provinceSelected: Sta;
    search = '';
    postal: any;
    locationSelected: any;
    categorySelected: any;
    startDate: Date | null = null;
    endDate: Date | null = null;
    protected readonly subBreakpointObserver = subBreakpointObserver;

    private readonly _adapter =
        inject<DateAdapter<unknown, unknown>>(DateAdapter);
    private readonly _intl = inject(MatDatepickerIntl);
    private readonly _locale = signal(inject<unknown>(MAT_DATE_LOCALE));
    readonly dateFormatString = computed(() => {
        if (this._locale() === 'fr') {
            return 'DD/MM/YYYY';
        } else if (this._locale() === 'en') {
            return 'MM/DD/YYYY';
        }
        return 'DD/MM/YYYY';
    });
    showFilters = false;
    isMobile = true;

    constructor(
        public bannersService: BannersService,
        public translate: TranslateService,
        private router: Router,
        private clientService: ClientService,
        private analyticsService: AnalyticsService,
        public helpsService: HelpsService,
        public filterPageService: FilterPageService,
        private route: ActivatedRoute,
    ) {}

    async ngOnInit() {
        const a = await this.helpsService.getGeoProvince();
        this.provinceSelected = a;

        // Configurer le format de date selon la langue
        this.setDateFormat();

        // S'abonner aux changements de langue
        this.translate.onLangChange.subscribe(() => {
            this.setDateFormat();
        });

        setTimeout(() => {
            const categoryParam = this.route.snapshot.queryParams['category'];
            if (categoryParam && this.category?.length) {
                const foundCategory = this.category.find((cat) => {
                    if (cat.id === categoryParam) {
                        return true;
                    }

                    return (
                        this.filterPageService.matchesSearch(
                            cat.nameLangue1,
                            categoryParam,
                        ) ||
                        this.filterPageService.matchesSearch(
                            cat.nameLangue2,
                            categoryParam,
                        ) ||
                        this.filterPageService.matchesSearch(
                            cat.smallName,
                            categoryParam,
                        ) ||
                        this.filterPageService.matchesSearch(
                            cat.id?.toString(),
                            categoryParam,
                        )
                    );
                });

                if (foundCategory) {
                    this.categorySelected = foundCategory;

                    this.searchEvent();
                }
            }
        });
    }

    ngOnChanges(changes: any) {
        // Réinitialiser les sélections si les listes changent
        if (changes.locationVenue && !changes.locationVenue.firstChange) {
            if (
                this.locationSelected &&
                !this.locationVenue?.some(
                    (loc) => loc.id === this.locationSelected?.id,
                )
            ) {
                this.locationSelected = null;
            }
            // Sélectionner automatiquement si il n'y a qu'un seul lieu
            if (
                this.locationVenue &&
                this.locationVenue.length === 1 &&
                !this.locationSelected
            ) {
                this.locationSelected = this.locationVenue[0];
            }
        }

        if (changes.category && !changes.category.firstChange) {
            if (
                this.categorySelected &&
                !this.category?.some(
                    (cat) => cat.id === this.categorySelected?.id,
                )
            ) {
                this.categorySelected = null;
            }
            // Sélectionner automatiquement si il n'y a qu'une seule catégorie
            if (
                this.category &&
                this.category.length === 1 &&
                !this.categorySelected
            ) {
                this.categorySelected = this.category[0];
            }
        }
        this.updateFilterService();
    }

    private setDateFormat() {
        const currentLang = this.translate.currentLang;
        if (currentLang === 'fr') {
            this._locale.set('fr');
            this._adapter.setLocale('fr');
            this.updateCloseButtonLabel('Fermer le calendrier');
        } else {
            this._locale.set('en');
            this._adapter.setLocale('en');
            this.updateCloseButtonLabel('Close calendar');
        }
    }

    private updateCloseButtonLabel(label: string) {
        this._intl.closeCalendarLabel = label;
        this._intl.changes.next();
    }

    selectProvince(st: Sta) {
        const temp = this.filterPageService.filter.value;
        const address = <Address>{
            province: st.ab,
        };
        //console.log(address)
        this.filterPageService.filter.next({
            ...temp,
            address: address,
            action: false,
        });
        this.provinceSelected = st;
        this.postal = null;
    }

    getDates(rangeDates: RangeDates) {
        //console.log(rangeDates);
        const temp = this.filterPageService.filter.value;
        this.filterPageService.filter.next({
            ...temp,
            ...rangeDates,
            action: false,
        });
    }

    searchEvent() {
        const temp = this.filterPageService.filter.value;
        let locationSelected = [];
        let categorySelected = [];
        if (!this.multiple) {
            locationSelected = [this.locationSelected];
            categorySelected = [this.categorySelected];
        } else {
            if (this.locationSelected) {
                locationSelected = this.locationSelected;
            }
            if (this.categorySelected) {
                categorySelected = this.categorySelected;
            }
        }
        locationSelected = locationSelected.filter((loc) => loc !== undefined);
        categorySelected = categorySelected.filter((cat) => cat !== undefined);

        this.filterPageService.filter.next({
            ...temp,
            search: this.search,
            startDate: this.startDate,
            endDate: this.endDate
                ? new Date(this.endDate.setHours(23, 59, 59, 999))
                : null,
            locationSelected: locationSelected,
            categorySelected: categorySelected,
            action: true,
            time: new Date().getTime(),
        });
    }

    stopPropagation($event: MouseEvent) {}

    selectLocation(_t67: LocationPage) {}

    clearFilter() {
        this.search = '';
        this.provinceSelected = null;
        this.postal = '';
        this.locationSelected = null;
        this.categorySelected = null;
        this.startDate = null;
        this.endDate = null;

        // Réinitialiser le service de filtrage
        this.filterPageService.filter.next({
            action: true,
            search: '',
            address: null,
            startDate: null,
            endDate: null,
            locationSelected: null,
            categorySelected: null,
        });
    }

    private updateFilterService() {
        const temp = this.filterPageService.filter.value;

        if (!this.multiple) {
            if (temp.categorySelected?.length === 1) {
                this.categorySelected = this.category.filter(
                    (value) => value.id === temp.categorySelected[0]?.id,
                )[0];
            }
            if (temp.locationSelected?.length === 1) {
                this.locationSelected = this.locationVenue.filter(
                    (value) => value.id === temp.locationSelected[0]?.id,
                )[0];
            }
        } else {
            this.categorySelected = temp.categorySelected;
            this.locationSelected = temp.locationSelected;
        }
        this.search = temp.search || '';
        this.startDate = temp.startDate || null;
        this.endDate = temp.endDate || null;
    }

    resetDates() {
        this.startDate = null;
        this.endDate = null;
        this.searchEvent();
    }

    toggleFilters() {
        this.showFilters = !this.showFilters;
    }

    protected readonly BreakpointsLib = BreakpointsLib;

    onDateRangePickerClosed() {
        // Appeler searchEvent() seulement si les deux dates sont sélectionnées
        if (this.startDate && this.endDate) {
            this.searchEvent();
        }
    }

    protected reset() {
        this.clearFilter();
        //this.searchEvent();
    }
}
